var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-gauge',{attrs:{"options":_vm.myOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }